module.exports = __webpack_public_path__ + "img/36.4.NH3-N.8af015d5.png";